import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../_core/_services/auth.service';
import { NotificationService } from '../../_core/_services/notification.service';
import { defaultRouteForRole, safeInternalReturnUrl } from '../../_core/_helpers/role-navigation.helper';

@Component({
  selector: 'app-tfa',
  standalone: false,
  templateUrl: './tfa.html',
  styleUrl: './tfa.css',
})
export class Tfa {
  loading = false;
  submitted = false;
  error: string | null = null;

  useRecovery = false;

  form!: FormGroup;

  constructor(
    private notifyService: NotificationService,
    private fb: FormBuilder,
    private auth: AuthService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.form = this.fb.nonNullable.group({
      code: ['', [Validators.required, Validators.pattern(/^\d{6}$/)]],
    });
  }

  get code() { return this.form.get('code'); }


  setMode(useRecovery: boolean) {
    this.useRecovery = useRecovery;

    const ctrl = this.form.get('code');
    if (!ctrl) return;

    ctrl.setValue('');
    ctrl.setValidators([
      Validators.required,
      useRecovery
        ? Validators.pattern(/^[A-Z2-9]{4}-[A-Z2-9]{4}$/)
        : Validators.pattern(/^\d{6}$/),
    ]);

    ctrl.updateValueAndValidity();
  }

  submit() {
    this.submitted = true;
    this.error = null;
    if (this.form.invalid) return;

    this.loading = true;

    let code = this.form.getRawValue().code.trim();
    if (this.useRecovery) code = code.toUpperCase();

    const call$ = this.useRecovery
      ? this.auth.verifyLoginRecovery(code)
      : this.auth.verifyLoginTotp(code);

    call$.subscribe({
      next: data => {
        const returnUrl = safeInternalReturnUrl(this.route.snapshot.queryParamMap.get('returnUrl'))
          ?? defaultRouteForRole(data.user?.role);
        this.router.navigateByUrl(returnUrl);
      },
      error: (err) => {
        const apiBody = err?.error;
        this.error =
          apiBody?.Message ||
          apiBody?.message ||
          apiBody?.Error?.Code ||
          apiBody?.error?.code ||
          (this.useRecovery ? 'Invalid recovery code.' : 'Invalid authenticator code.');

        this.notifyService.showError(this.error!, 'Error');
        this.loading = false;
      },
      complete: () => (this.loading = false),
    });
  }

  cancel() {
    this.auth['tokens'].clearTotpChallengeToken();
    this.router.navigateByUrl('/auth/login');
  }
}